import React from 'react';
import classNames from 'classnames/bind';
import { DEFAULT_ICONS } from "./constants";
import { CARD_TYPE } from "../../utils/constants";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var ImageCell = function ImageCell(_ref) {
  var src = _ref.src,
    type = _ref.type,
    isSmall = _ref.isSmall;
  if (type !== CARD_TYPE.product || !src && type === CARD_TYPE.product) {
    var Icon = DEFAULT_ICONS[type];
    return /*#__PURE__*/React.createElement(Icon, {
      className: cx('icon-default', {
        'icon-default__size-m': !isSmall
      }),
      color: "tertiary-invert",
      "data-t-id": "blocks-ImageCell"
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: cx('icon')
  }, /*#__PURE__*/React.createElement("img", {
    alt: "\u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430",
    src: src
  }));
};